var exports = {
  "Pf": "MyProfileTabUsernameSection.module__label___eUo5dE",
  "o1": "MyProfileTabUsernameSection.module__actions___eUo5dE",
  "Sn": "MyProfileTabUsernameSection.module__premiumButton___eUo5dE",
};

module.exports = exports;
